module.exports = __webpack_public_path__ + "img/right-icon.0a578b0a.svg";